import { Component } from '@angular/core';

@Component({
  selector: 'mzic-colors-components',
  templateUrl: './colors.component.html',
  styleUrls: ['./colors.component.scss'],
  standalone: false,
})
export class ColorsComponent {}
